// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__aKRaj","label":"default_label__U2bC8","text":"default_text__VK-FY","link":"default_link__4R6m2"};